import { render, staticRenderFns } from "./SubmitPapers.vue?vue&type=template&id=55039b67&"
import script from "./SubmitPapers.vue?vue&type=script&lang=js&"
export * from "./SubmitPapers.vue?vue&type=script&lang=js&"
import style0 from "./SubmitPapers.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports